module.exports = __webpack_public_path__ + "static/hero4-11fb390cd93706b741d9d8d4ff9bfcb0.png";